export const DS_TOKEN_INPUT_CLASSES = {
  Root: "ds-token-input",
  Chip: "ds-token-input__chip",
  ChipGroupEnd: "ds-token-input__chip--group-end",
  Draft: "ds-token-input__draft",
  Mirror: "ds-token-input__mirror",
  LiveRegion: "ds-token-input__live-region",
} as const;
